const REDIRECT_VALIDATION_BASE = 'https://redirect-validator.invalid';

/**
 * ログイン後遷移先の redirect クエリを正規化し、同一オリジン内の相対パスであることを検証する。
 */
export const normalizeRedirect = (redirect: string | null | undefined): string | undefined => {
  if (redirect == null) return undefined;

  const trimmed = redirect.trim();
  if (!trimmed) return undefined;

  try {
    const url = new URL(trimmed, REDIRECT_VALIDATION_BASE);
    if (url.origin !== REDIRECT_VALIDATION_BASE) return undefined;
    if (url.pathname.startsWith('//')) return undefined;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return undefined;
  }
};

export const isSafeRedirect = (redirect: string | null | undefined): redirect is string => normalizeRedirect(redirect) !== undefined;
